// Où arrive un compte juste après la connexion (ou en rouvrant tuteur.ai déjà connecté).
// Formateur KIDSHAKER : « Ma classe », son outil principal (Yann 08/10/2026).
// Administrateur (profiles.is_admin) : « Ma classe » aussi, même règle que le menu et la garde
// de l'espace formateur (Yann 14/10/2026).
// Élève DÉCLIC (profiles.declic_enabled) : « Aujourd'hui », le plan du jour (lot 2, 12/10/2026).
// Tous les autres comptes gardent leur page habituelle, passée par l'appelant.
export const ACCUEIL_FORMATEUR = "/formateur"
export const ACCUEIL_DECLIC = "/aujourdhui"

export function destinationApresConnexion(
  role: string | null | undefined,
  parDefaut: string,
  declicEnabled?: boolean | null,
  isAdmin?: boolean | null,
): string {
  if (role === "formateur" || isAdmin === true) return ACCUEIL_FORMATEUR
  return declicEnabled === true ? ACCUEIL_DECLIC : parDefaut
}
